import { WILLS_META_LP_CTA } from 'lib/@getethos/experiments/constants'

export const getWillsMetaCTAText = (
  variation: string,
  defaultCtaLabel: string | undefined
) => {
  switch (variation) {
    case WILLS_META_LP_CTA.VARIATIONS.TREATMENT_1:
      return 'Learn more'
    case WILLS_META_LP_CTA.VARIATIONS.TREATMENT_2:
      return 'See how it works'
    case WILLS_META_LP_CTA.VARIATIONS.TREATMENT_3:
      return 'Try for free'
    default:
      return defaultCtaLabel
  }
}
